import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SocialPage from './pages/SocialPage';
import AboutPage from './pages/AboutPage';
import styled, { createGlobalStyle } from 'styled-components';
import './App.css';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background-color: #1e272e;
    min-height: 100vh;
    background-image: url('/pixel-bg.svg');
    background-size: 32px 32px;
    background-attachment: fixed;
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: transparent;
  color: #ffffff;
  padding-top: 4.5rem; /* Height of navbar + some extra space */
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

const App: React.FC = () => {
  return (
    <Router>
      <GlobalStyle />
      <AppContainer>
        <Navbar />
        <MainContent>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/games" element={<div>Games Page</div>} />
            <Route path="/social" element={<SocialPage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
  );
};

export default App;
